import { Injectable } from '@angular/core'
import { environment } from 'src/environments/environment'

export type LogLevel = 'debug' | 'info' | 'warn' | 'error'

const LOG_LEVEL_ORDER: LogLevel[] = ['debug', 'info', 'warn', 'error']

export interface LogContext {
  [key: string]: unknown
}

@Injectable({ providedIn: 'root' })
export class LoggerService {
  private readonly minLevel: LogLevel = environment.production ? 'warn' : 'debug'

  private shouldLog(level: LogLevel): boolean {
    return LOG_LEVEL_ORDER.indexOf(level) >= LOG_LEVEL_ORDER.indexOf(this.minLevel)
  }

  debug(message: string, context?: LogContext): void {
    if (this.shouldLog('debug')) {
      console.debug(`[DEBUG] ${message}`, context ?? '')
    }
  }

  info(message: string, context?: LogContext): void {
    if (this.shouldLog('info')) {
      console.info(`[INFO] ${message}`, context ?? '')
    }
  }

  warn(message: string, context?: LogContext): void {
    if (this.shouldLog('warn')) {
      console.warn(`[WARN] ${message}`, context ?? '')
    }
  }

  error(message: string, context?: LogContext): void {
    console.error(`[ERROR] ${message}`, context ?? '')
  }
}
